import { SITE_ROUTES } from "./site-routes";

export const SITE_ORIGIN = "https://upsquad.us";

export const SITE_CONFIG = {
	name: "UpSquad",
	legalName: "UpSquad, Inc.",
	contactEmail: "hello@upsquad.com",
	address: {
		line1: "3618 Walker Ave",
		city: "Memphis",
		state: "TN",
		zip: "38152",
		country: "USA",
	},
	socials: {
		linkedin: "https://www.linkedin.com/company/upsquad",
		x: "https://x.com/upsquad",
	},
	primaryNav: [
		{ key: "features", to: SITE_ROUTES.FEATURES },
		{ key: "pricing", to: SITE_ROUTES.PRICING },
		{ key: "about", to: SITE_ROUTES.ABOUT },
	],
	footerSections: [
		{
			titleKey: "footer.product",
			links: [
				{ key: "footer.features", to: SITE_ROUTES.FEATURES },
				{ key: "footer.pricing", to: SITE_ROUTES.PRICING },
				{ key: "footer.demo", to: "/#demo" },
			],
		},
		{
			titleKey: "footer.company",
			links: [
				{ key: "footer.about", to: SITE_ROUTES.ABOUT },
				{ key: "footer.careers", to: SITE_ROUTES.CAREERS },
				{ key: "footer.contact", to: SITE_ROUTES.CONTACT },
			],
		},
		{
			titleKey: "footer.legal",
			links: [
				{ key: "footer.privacy", to: SITE_ROUTES.PRIVACY },
				{ key: "footer.terms", to: SITE_ROUTES.TERMS },
				{ key: "footer.legal_notices", to: SITE_ROUTES.LEGAL_NOTICES },
			],
		},
	],
};
